// Components
import { AppRouterSWRConfigWrapper } from '@/components/layouts/AppRouterSWRConfigWrapper';
import { GlobalWrapper } from '@/components/layouts/LayoutPlatform/GlobalWrapper';
import { HeaderPlatform } from '@/components/layouts/LayoutPlatform/components/Header';

type LayoutPlatformProps = { children: React.ReactNode };

/**
 * LayoutPlatform for App Router contexts
 * For Pages Router contexts, use LayoutPlatformContent wrapped with PagesRouterSWRConfigWrapper
 */
function LayoutPlatform({ children }: LayoutPlatformProps) {
    return (
        <AppRouterSWRConfigWrapper>
            <LayoutPlatformContent>{children}</LayoutPlatformContent>
        </AppRouterSWRConfigWrapper>
    );
}

/**
 * The visual content of LayoutPlatform without SWR wrapper
 * Use this when you need to provide your own SWR wrapper (e.g., in Pages Router)
 */
function LayoutPlatformContent({ children }: LayoutPlatformProps) {
    return (
        <div className="flex h-screen w-screen overflow-hidden bg-white bg-icoLoggedInLayer dark:bg-icoDarkMode-deepBlack dark:bg-icoLoggedInLayerDark">
            <GlobalWrapper>{children}</GlobalWrapper>
        </div>
    );
}

export { HeaderPlatform, LayoutPlatform, LayoutPlatformContent };
